// extracted by mini-css-extract-plugin
export default {"faq_container":"Faq_faq_container__XAZk1","faq_inner":"Faq_faq_inner__Z4-io","logo":"Faq_logo__NTctV","header":"Faq_header__A8AYz"};